import {inject, Injectable} from '@angular/core';
import {
  BaseProductPackageData,
  ProductPackageData,
  ProductPackageFile
} from "../types/product-package-modal.types";
import {GetDataInModalParams} from "../../../../types/product-card-modals.types";
import {
  productPackageResourceType
} from "../configs/product-package-modal-config";
import {
  AttachProductCardFileParams,
  DeleteFileParams,
  GetFilesParams
} from "../../../../types/product-card-files.types";
import {BaseModalApiService} from "../../../../../../../core/components/modals/services/base-modal-api.service";
import {ProductCardApiService} from "../../../../services-api/product-card-api.service";
import {ProductCardFilesApiService} from "../../../../services-api/product-card-files-api.service";
import {RecordTableApiService} from "../../../../../../../core/services-api/record-table-api.service";
import {
  GetSelectDataParams,
  RecordUpdateRequestParams,
  SelectData
} from "../../../../../../../core/types/records-table.types";

@Injectable({
  providedIn: 'root'
})
export class ProductPackageModalService {
  private baseModalApiService: BaseModalApiService = inject(BaseModalApiService);
  private productCardApiService: ProductCardApiService = inject(ProductCardApiService);
  private productCardFilesApiService: ProductCardFilesApiService = inject(ProductCardFilesApiService);
  private recordTableApiService: RecordTableApiService = inject(RecordTableApiService);

  public createProductPackage(createProductPackageParams: BaseProductPackageData): Promise<ProductPackageData> {
    return new Promise((resolve, reject) => {
      this.baseModalApiService.createDataInModal<BaseProductPackageData, ProductPackageData>(createProductPackageParams, productPackageResourceType.path).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }

  public getDataInModal<T>(getDataInModalParams: GetDataInModalParams): Promise<Array<T>> {
    return new Promise((resolve, reject) => {
      this.productCardApiService.fetchDataInModal<T>(getDataInModalParams).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }

  public updatedRecordField<T>(recordUpdateRequestParams: RecordUpdateRequestParams): Promise<T> {
    return new Promise((resolve, reject) => {
      this.recordTableApiService.updateRecord<T>(recordUpdateRequestParams).subscribe({
        next: (recordData: T) => resolve(recordData),
        error: (error) => reject(error)
      });
    });
  }

  public getFiles(getFilesParams: GetFilesParams): Promise<Array<ProductPackageFile>> {
    return new Promise((resolve, reject) => {
      this.productCardFilesApiService.fetchFiles<ProductPackageFile>(getFilesParams).subscribe({
        next: (data) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }

  public deleteFile(deleteFileParams: DeleteFileParams): Promise<void> {
    return new Promise((resolve, reject) => {
      this.productCardFilesApiService.deleteFile(deleteFileParams).subscribe({
        next: () => resolve(),
        error: (error) => reject(error)
      });
    });
  }

  public attachFile<T>(attachProductCardFileParams: AttachProductCardFileParams): Promise<T> {
    return new Promise((resolve, reject) => {
      this.productCardFilesApiService.attachFile<T>(attachProductCardFileParams).subscribe({
        next: (data: T) => resolve(data),
        error: (error) => reject(error)
      });
    });
  }

  public fetchSelectData(getSelectDataParams: GetSelectDataParams): Promise<Array<SelectData>> {
    return new Promise((resolve, reject) => {
      this.recordTableApiService.fetchSelectData(getSelectDataParams).subscribe({
        next: (selectData: Array<SelectData>) => resolve(selectData),
        error: (error) => reject(error)
      });
    });
  }
}
